document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-mobile-menu-button]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (button && drawer) {
    button.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-auto-submit] input, [data-auto-submit] select').forEach((field) => {
    field.addEventListener('change', () => field.form && field.form.submit());
  });
});


// Keep price and add-to-cart state in sync when a variant changes.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const root = select.closest('[data-product-root]');
  if (!root) return;
  const json = root.querySelector('[data-variant-json]');
  if (!json) return;
  let variants = [];
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  const variant = variants.find((item) => String(item.id) === String(select.value));
  if (!variant) return;

  const currency = root.dataset.currency || 'USD';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
    }
  };

  const price = root.querySelector('.product-price');
  if (price) {
    price.textContent = money(variant.price);
    if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
      const compare = document.createElement('span');
      compare.className = 'compare-price';
      compare.textContent = money(variant.compare_at_price);
      price.appendChild(compare);
    }
  }
  const button = root.querySelector('button[name="add"]');
  if (button) {
    button.disabled = !variant.available;
    button.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }
});
